module.exports = __webpack_public_path__ + "static/media/booth.59c69932.png";